export function cleanNewAmountValue(value: string | null | undefined) {
  if (value === "" || value === null || value === undefined) {
    return 0;
  }

  // Remove dots used for thousands
  const cleanedValue = value.replace(/\./g, "");

  // Replace comma with dot for decimal point
  const replacedComma = cleanedValue.replace(",", ".");

  // Convert to float
  const parsedValue = Number.parseFloat(replacedComma);

  // Return the parsed value or 0 if conversion fails
  return isNaN(parsedValue) ? 0 : parsedValue;
}

export function cleanNewAmountValueCanvas(value: string | null | undefined) {
  if (value === "" || value === null || value === undefined) {
    return 0;
  }

  // Remove dots used for thousands
  let cleanedValue = value; //.replace(/\./g, "");

  const decimalRegex = /(\.\d{2}[^0-9]*$|\,\d{2}[^0-9]*$)/;

  if (decimalRegex.test(cleanedValue)) {
    // Replace the decimal comma with a dot
    cleanedValue = cleanedValue.replace(",", ".");
  } else {
    // Remove all commas
    cleanedValue = cleanedValue.replace(/,/g, "");
  }

  // Remove all dots except the last one, assuming it's a decimal point
  const parts = cleanedValue.split(".");
  cleanedValue =
    parts.length > 1
      ? parts.slice(0, -1).join("") + "." + parts.slice(-1)
      : cleanedValue;

  const hasTrailingMinus = cleanedValue.endsWith("-");

  // Remove the trailing minus if it exists
  if (hasTrailingMinus) {
    cleanedValue = cleanedValue.slice(0, -1);
  }

  // Convert to float
  let parsedValue = Number.parseFloat(cleanedValue);

  if (hasTrailingMinus) {
    parsedValue = -Math.abs(parsedValue);
  }

  // Return the parsed value or 0 if conversion fails
  return isNaN(parsedValue) ? 0 : parsedValue;
}

export function adjustBruttoNetto(
  value: number,
  fieldType: string,
  vatRate: number,
) {
  if (fieldType === "Netto") {
    return value / (1 + vatRate / 100);
  } else {
    return value;
  }
}
